import React from 'react';

import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';

export const DefaultServerTitleWrapper: React.FunctionComponent<{}> = props => {
  React.useEffect(() => {
    BrowserTitleService.setTitleToServerName();
  }, []);

  return <>{props.children}</>;
};
